import { css } from '@emotion/react';

import { palette } from '@lib/styles/palette';
import pixelToRem from '@lib/styles/pixelToRem';

function SkeletonQuickSearch({ isSelected }: { isSelected: boolean }) {
  return (
    <section css={defaultSkeletoStyle}>
      <div className="heading" />
      <div className="description" />
      <div className="content">
        {!isSelected ? (
          <ul className="searchmenu list">
            <li className="listItem"></li>
            <li className="listItem"></li>
            <li className="listItem"></li>
          </ul>
        ) : (
          <div className="detailsearch list">
            <div className="selectionContainer">
              <h2 className="heading" />
              <div className="modelContainer">
                <h3>기종</h3>
                <div className="modelItem" />
              </div>
              <div className="optionContainer">
                <h3>세부항목</h3>
                <div className="optionItem" />
              </div>
            </div>
            <div className="chart" />
          </div>
        )}
      </div>
    </section>
  );
}

const defaultSkeletoStyle = css`
  width: 100%;
  height: auto;

  .heading {
    width: 30%;
    height: 20px;
    background-color: ${palette.gray2};
    margin-bottom: 3px;
    border-radius: 4px;
  }

  .description {
    width: 35%;
    height: 20px;
    background-color: ${palette.gray2};
    border-radius: 4px;
  }

  .searchmenu {
    width: 100%;
    min-width: 470px;
    display: flex;
    flex-direction: row;
    overflow: hidden;
    flex-wrap: nowrap;
    padding-top: 26px;
    padding-bottom: 36px;
  }

  .listItem {
    display: inline-block;
    width: 130px;
    height: 130px;
    background: ${palette.gray2};
    margin-right: 16px;
    border-radius: 4px;
  }

  @media (max-width: 599px) {
    padding: ${pixelToRem(0, 20)};
    margin-top: ${pixelToRem(24)};
  }
`;

export default SkeletonQuickSearch;
